import React, {Component} from 'react'
import {observer, inject} from 'mobx-react'
import {Button} from 'antd'
import Tag from './Tag'
import Operator from './Operator'
import Value from './Value'
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome'

import style from './style.sass'

@inject('store') @observer
class Condition extends Component {
  removeCondition = () => {
    this.props.store.stockFilter.single.removeCondition(this.props.id)
  }
  render() {
    const {stockFilter} = this.props.store
    const {conditions} = stockFilter.single.data
    return (
      <div styleName='wrapper'>
        <Tag condition={this.props.condition}/>
        <Operator condition={this.props.condition}/>
        <Value condition={this.props.condition}/>
        <Button
          type='default'
          size='large'
          onClick={this.removeCondition}
          disabled={conditions.length < 2}
        >
          <FontAwesomeIcon icon='times'/>
        </Button>
      </div>
    )
  }
}

export default Condition
